<template>
  <div>

    <div class="flex flex-row space-x-4">

      <div class="text-sm w-full">
        <div class="" v-if="metadatas.length" style="">
          <div v-for="(metadata, i) in metadatas" class="w-full mb-2">
            <label for="value" class="w-full label">
              {{ $t(metadata.name) }}
              <b-tooltip v-if="metadata.info" :label="metadata.info" position="is-top">
                  <b-icon pack="fas" icon="circle-info" />
              </b-tooltip>
            </label>
            
            <b-select
              v-if="metadata.type == 'select'"
              v-model="metadatas[i].value"
              :placeholder="metadata.placeholder"
              class="w-full"
              :required="metadata.required"
              expanded
            >
              <option v-for="option in metadata.data" :value="option['value']" :key="option['value']">
                {{ option['name'] }}
              </option>
            </b-select>

            <b-switch
              v-else-if="metadata.type == 'checkbox'"
              v-model="metadatas[i].value"
              :required="metadata.required"
            >{{ $t(metadata.value ? 'yes' : 'no') }}
            </b-switch>

            <treeselect 
              v-else-if="metadata.type == 'treeselect' && metadata.field == 'activity'"
              v-model="metadatas[i].value" 
              :close-on-select="false" 
              :options="metadata.data" 
              :required="metadata.required"
              :multiple="true"
              @select="loadActivityFolders"
              @deselect="removeActivityFolders"
              :beforeClearAll="resetActivityFolders"
            />

            <treeselect 
              v-else-if="metadata.type == 'treeselect' && metadata.field != 'activity' && metadata.field != 'task_code'"
              v-model="metadatas[i].value" 
              :close-on-select="true" 
              :required="metadata.required"
              :options="metadata.data" 
            />

            <multiselect 
              v-else-if="metadata.type == 'multiselect'" 
              class="w-full"
              :data="metadata.data"
              ref="multiselect"
              @updated="metadatas[i].value = $event.join(',')"
            />

            <button v-else-if="metadata.field == 'task_code'" class="button w-full" v-on:click="showTasksModal">Configurar tareas</button>
            <button v-else-if="metadata.field == 'folder' && metadata.type == 'config'" class="button w-full" v-on:click="showFolderModal(metadata.value)">Configurar carpetas</button>

            <v-input
              v-else
              v-model="metadatas[i].value"
              :placeholder="metadata.placeholder"
              class="w-full"
              :required="metadata.required"
            />

          </div>                        
        </div>
      </div>
    </div>

    <rule-config-task ref="rule_config_task" />
    <rule-config-folder ref="rule_config_folder" @close-modal="updateDataFolders"/>

  </div>
</template>

<script>
import axios from 'axios'
import { mapGetters } from 'vuex'
import Treeselect from '@riophae/vue-treeselect'
import '@riophae/vue-treeselect/dist/vue-treeselect.css'
import RuleConfigTask from './rule-config-task'
import RuleConfigFolder from './rule-config-folder'
import Multiselect from "../../multiselect"

export default {
  components: {
    Treeselect,
    RuleConfigTask,
    RuleConfigFolder,
    Multiselect
  },

  props: {
    projectRule: {type: Object, default: null },
    projectId: {type: Number},
    templates: {type: Array},
  },


  data: () => ({
    isModalActive: false,
    item: {},
    editItem: {},
    metadatas: [],
    statusList: [],
    activities: [],
    templatesList: [],
    currentFolders: [],
    validationStatus: [
      { name: 'Creado', value: 'created' },
      { name: 'Completado', value: 'completed' },
    ]
  }),

  computed: {
    ...mapGetters({
      company: 'app/company',
    }),
  },

  mounted () {
    this.getStatusList()
    this.loadActivities()
    this.getTemplates()
  },

  watch:{
    projectRule(val) {
      this.reloadForm()
    },
  },

  methods: {

    async getStatusList() {
      let data = await axios.get('/api/v2/project/' + this.projectId + '/statuses');

      if (data.data && data.data.success) {
        this.statusList = data.data.statuses.map(status => ({
          name: status.name,
          value: status.id
        }));
      }
      
      this.reloadForm()
    },

    async reloadForm() {
      this.$refs.rule_config_task.data = []
      this.loadMetadata()
    },

    async showTasksModal() {
      this.$refs.rule_config_task.show(this.templates)
    },
  
    async showFolderModal(data) {
      this.$refs.rule_config_folder.show(data)
    },

    async getTemplates() {
      const { data } = await axios.get("/api/v2/validations/templateImportsList", {'params' : { company_id: this.company.id }});
      let templateIds = this.templates.map(t => t.id)
      if (data.templates) {
        this.templatesList = data.templates.filter(t => !templateIds.includes(t.id)).map(template => {
          return {
            id: template.code,
            label: template.name
          }
        });
      }
      this.reloadForm()
    },

    async loadActivities() {
      const { data } = await axios.get("/api/v2/activities", {'params' : { p : this.projectId, tree: 1}});
      this.activities = data.activities.map(activity => {
        return {
          id: activity.planning_code,
          activityId: activity.id,
          label: activity.name,
          children: activity.children_activities.map(subactivity => {
            return {
              id: subactivity.planning_code,
              activityId: subactivity.id,
              label: subactivity.name
            }
          })
        }
      });
      this.reloadForm()
    },

    async loadActivityFolders(node) {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].field == 'folder' && this.metadatas[i].type == 'config') {
          let { data } = await axios.get("/api/v2/activity/"+node.activityId, {'params' : { with_folders: 1}});
          this.metadatas[i].value[node.id] = {
            label: node.label,
            value: null,
            folders: this.getFolders(data.data.folders)
          }
          return
        }
      }
    },

    removeActivityFolders(node) {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].field == 'folder' && this.metadatas[i].type == 'config') {
          delete this.metadatas[i].value[node.id]
          return
        }
      }
    },

    resetActivityFolders() {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].field == 'folder' && this.metadatas[i].type == 'config') {
          this.metadatas[i].value = {}
          return true
        }
      }
    },

    updateDataFolders(folders) {
      for (let i = 0; i < this.metadatas.length; i++) {
        if (this.metadatas[i].field == 'folder' && this.metadatas[i].type == 'config') {
          this.metadatas[i].value = folders
          return
        }
      }
    },

    getFolders(folders) {

      var map = {}, node, roots = [], i;

      for (i = 0; i < folders.length; i += 1) {
        map[folders[i].id] = i; // initialize the map
        folders[i].children = []; // initialize the children
      }

      for (i = 0; i < folders.length; i += 1) {
        node = folders[i];
        if (node.parent_id !== null) {
          folders[map[node.parent_id]].children.push({id: node.id, label: node.name, children: node.children});
        } else {
          roots.push({id: node.id, label: node.name, children: node.children});
        }
      }

      this.cleanEmptyChildrens(roots)

      return roots;
    },

    // limpia los nodos eliminando la key 'children' si está vacio
    cleanEmptyChildrens(tree) {

      for (let i = 0; i < tree.length; i += 1) {

        // Caso base 1. No tiene la key 'children', do nothing
        if (!tree[i].children)
          return true

        // Caso base 2. Tiene la key vacia, eliminarla
        if (tree[i].children && tree[i].children.length == 0) {
          delete tree[i].children
          return true;

        // tiene childrens, pues llamar recursivamente
        } else {
          this.cleanEmptyChildrens(tree[i].children)
        }
      }
      return true

    },

    loadMetadata() {
      this.metadatas = []
      if (this.projectRule) {
        switch (this.projectRule.code) {
          case 'sendMailCompletion':
            this.metadatas = [
              {
                name: 'Correos',
                field: 'emails',
                value: '',
                placeholder: 'Correos a los que enviar email',
                required: true
              },
              {
                name: 'Mensaje',
                field: 'message',
                value: '',
                placeholder: 'Cuerpo de mensaje',
                required: true
              },
              {
                name: 'Agregar documentos',
                field: 'with_documents',
                value: false,
                placeholder: 'Incluir documentos en correo (1,0)',
                required: false,
                type: 'checkbox',
              }
            ]              
            break;
          case 'periodicCreation':
            this.metadatas = [
              {
                name: 'Día',
                field: 'day_month',
                value: '',
                placeholder: '01',
                required: true
              },
              {
                name: 'Seleccione actividad',
                field: 'activity',
                value: null,
                placeholder: 'Seleccione actividad o subactividad',
                required: true,
                type: 'treeselect',
                data: this.activities
              },
              {
                name: 'Carpetas (Opcional)',
                field: 'folder',
                value: {},
                placeholder: 'carpeta para documentos',
                required: false,
                type: 'config',
                data: []
              }
            ]              
            break;
          case 'uncompletedFlowLock':
            this.metadatas = [
              {
                name: 'Flujo de validación',
                field: 'template_code',
                value: null,
                placeholder: 'Seleccione flujo de validación',
                required: true,
                type: 'treeselect',
                data: this.templatesList,
                info: 'Flujo de validación que tiene que completarse antes'
              },
              {
                name: 'Estado a validar',
                field: 'status',
                value: null,
                placeholder: 'Selecciona estado',
                required: true,
                type: 'select',
                data: this.validationStatus
              },
              {
                name: 'Seleccione actividad',
                field: 'activity',
                value: null,
                placeholder: 'Seleccione actividad o subactividad',
                required: true,
                type: 'multiselect',
                data: this.activities
              },
            ]              
            break;
          case 'changeActivityStatusTaskCompletion':
            this.metadatas = [
              {
                name: 'Seleccione actividad',
                field: 'activity',
                value: null,
                placeholder: 'Seleccione actividad o subactividad',
                required: true,
                type: 'treeselect',
                data: this.activities
              },
              {
                name: 'Tarea',
                field: 'task_code',
                value: null,
                placeholder: 'Selecciona tarea',
                required: true,
                type: 'treeselect',
                data: []
              },
              {
                name: 'Estado de actividad',
                field: 'status',
                value: null,
                placeholder: 'Selecciona estado',
                required: true,
                type: 'select',
                data: this.statusList
              },
            ]
            break;
          case 'automaticFlowCreation':
            this.metadatas = [
              {
                name: 'Código del flujo',
                field: 'template_code',
                value: '',
                placeholder: 'Código de flujo de validación',
                required: true
              },
              {
                name: 'Código actividad (sin prefijos)',
                field: 'activity',
                value: '',
                placeholder: 'Código de actividad o subactividad',
                required: true
              },
              {
                name: 'Carpeta (Opcional)',
                field: 'folder',
                value: '',
                placeholder: 'Folder1/Folder2/...',
                required: false
              }
            ]
            break;
        
          default:
            break;
        }
      }
    },

    isCompleted() {
      if (this.metadatas.length == 0) {
        return false
      }
      return this.metadatas.every(m => {
        let isCompleted = true
        if (m.required) {
          if (m.field == 'task_code' && this.$refs.rule_config_task.data.every(t => {return !!t.taskSelected})) {
            isCompleted = true
          } else {
            isCompleted = !!m.value
          }
        }
        return isCompleted
      })
    },

    getForm() {
      let form = {}
      this.metadatas.map(m => {
        if (m.field == 'folder' && m.type == 'config') {
          let folderConfig = {}
          for (let key in m.value) {
            folderConfig[key] = m.value[key].value
          }
          form[m.field] = folderConfig
        } else {
          form[m.field] = m.value
        }
      })
      form.tasks_selected = this.$refs.rule_config_task.data.map(t => {
        return {
          template_id: t.template.id,
          task: t.taskSelected
        }
      })
      return form
    }
  },

};
</script>
